import React, { useState } from "react";
import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { Button, Checkbox, Form, Input, Space } from 'antd';
import { useNavigate } from "react-router-dom";
import { Link } from 'react-router-dom';

const LogOut = () =>  {
    const navigator = useNavigate();
    navigator('./login')
    return( <div className="logout ">
       { 
      // 
       
       
 
  }
       

</div>);
   
}
export default LogOut;